// --------------------------------------------------------------
// Created On: 2024-08-21
// Author: KC Willard
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./TemplateListRow.module.scss";

// A single template in a list of templates.
export default function TemplateListRow(props: Props): Component {
  return (
    <div className="p-2" data-test="template-list-row">
      <span>{props.name}</span>
      {props.isImmutable && <span className={styles.defaultTag}>Default</span>}
      {props.isPreset && <span className={styles.presetTag}>Preset</span>}
    </div>
  );
}

interface Props {
  assetTemplateId: number;
  name: string;
  isImmutable: boolean;
  isPreset: boolean;
}
